//
// Check WebP
// --------------------------------------------------
// Creates a webp image and checks if the browser sees it as a valid image
// and returns the result as a class that we can target for webp images in css e.g. background images.

async function supportsWebp() {
    if (!self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then(r => r.blob());
    return createImageBitmap(blob).then(() => true, () => false).catch(() => false);
}

supportsWebp().then((res) => {
    document.documentElement.classList.add(res ? 'webp' : 'no-webp');
});